import { createFileRoute } from "@tanstack/react-router";
import ContainerInset from "@/components/container-inset.tsx";
import PageLayoutRoot, {
  PageLayoutContent,
  PageLayoutHeader,
} from "@/components/page-layout.tsx";
import AddCustomerForm from "@/app/(authenticated)/$merchantId/customers/add/_components/add-customer-form.tsx";
import { useMerchantProvider } from "@/app/(authenticated)/_providers/merchant-provider.tsx";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/customers/add/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { selectedMerchant } = useMerchantProvider();
  return (
    <ContainerInset
      breadcrumbs={[
        {
          title: "Customers",
          href: `/${selectedMerchant?.merchAccountId}/customers`,
        },
        {
          title: "Add New Customer",
          href: "#",
        },
      ]}
    >
      <PageLayoutRoot>
        <PageLayoutHeader
          title="Add New Customer"
          description="Set up a new automated payment schedule for your customer"
        />

        {/* Main Form */}
        <PageLayoutContent>
          {selectedMerchant?.merchAccountId && (
            <AddCustomerForm merchantId={selectedMerchant?.merchAccountId} />
          )}
        </PageLayoutContent>
      </PageLayoutRoot>
    </ContainerInset>
  );
}
